module.exports = __webpack_public_path__ + "static/media/failed-transaction.f1baed90.svg";